
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/api",
      function () {
        return require("private-next-pages/settings/api.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/api"])
      });
    }
  